import { useState, useEffect } from "react";
import { getAuth, onAuthStateChanged, signOut, signInWithEmailAndPassword, createUserWithEmailAndPassword } from "firebase/auth";
import { getFirestore, collection, getDocs, doc, setDoc, updateDoc, query, getDoc, deleteDoc, onSnapshot } from "firebase/firestore";
// import { getMessaging, onMessage } from "firebase/messaging";
import firebaseConfig from "./firebaseConfig"; // Firebase configuration file
import HomeSection from "./components/HomeSection";
import QuizSection from "./components/QuizSection";
import AddQuestionsSection from "./components/AddQuestionsSection";
import ProfileSection from "./components/ProfileSection.js";
// import AdminPanel from "./components/AdminPanel";
import AccountLimitModal from "./components/AccountLimitModal"; // ADD
import { auth, db, messaging } from "./firebase";
import "./Inter-VariableFont_slnt,wght.ttf"; // Import the font
import Lottie from "lottie-react";
import loadingAnimation from "./lottie/loading-animation.json";
import loadingAnimation2 from "./lottie/loading-animation-2.json"; // Adjust path if needed
import React, { useRef } from "react";
import Logo from "./assets/new logo.svg";

const sections = [
  { id: "home", title: "Home", icon: (
      // New home icon: simple outline house (Material style)
      <svg width="22" height="22" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
        <path d="M4 12L12 5l8 7" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M5 12v7a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-7" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>
    ) },
  { id: "quiz", title: "Quiz", icon: (
      <svg width="22" height="22" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
        <rect x="4" y="4" width="16" height="16" rx="2" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M8 10h8M8 14h4" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>
    ) },
  { id: "addQuestions", title: "Add", icon: (
      <svg width="22" height="22" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
        <circle cx="12" cy="12" r="10" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M12 8v8M8 12h8" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>
    ) },
  { id: "profile", title: "Profile", icon: (
      <svg width="22" height="22" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
        <circle cx="12" cy="8" r="4" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M4 20c0-4 8-4 8-4s8 0 8 4" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>
    ) },
];

export default function App() {
  const [activeSection, setActiveSection] = useState("home");
  const [user, setUser] = useState(null);
  const [notifications, setNotifications] = useState([]);
  const [showLogin, setShowLogin] = useState(false);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loginError, setLoginError] = useState(""); // For login error messages
  const [signUpError, setSignUpError] = useState(""); // For sign-up error messages
  const [loading, setLoading] = useState(false); // For showing a loading state
  const [accountType, setAccountType] = useState("free"); // Default to free account
  const [showAccountLimitModal, setShowAccountLimitModal] = useState(false);
  const [appLoading, setAppLoading] = useState(true);
  const [menuOpen, setMenuOpen] = useState(false);
  const [aboutOpen, setAboutOpen] = useState(false);
  const [helpOpen, setHelpOpen] = useState(false);
  const [legalOpen, setLegalOpen] = useState(false);
  const [settingsOpen, setSettingsOpen] = useState(false);
  const [deleteOpen, setDeleteOpen] = useState(false);
  const [deletePassword, setDeletePassword] = useState("");
  const [deleteError, setDeleteError] = useState("");
  const [deleteLoading, setDeleteLoading] = useState(false);
  const [deleteSuccess, setDeleteSuccess] = useState(false);
  const [agreeToTerms, setAgreeToTerms] = useState(false);
  const [stats, setStats] = useState({}); // For user stats
  const menuRef = useRef();

  // Show loading animation only while Firebase/auth is initializing
  // and ensure it plays at least once (1.5s)
  const [minTimePassed, setMinTimePassed] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setMinTimePassed(true), 1200);
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
      setUser(currentUser);
      setAppLoading(false); // Only hide loading when auth state is known
    });
    return () => unsubscribe();
  }, []);

  useEffect(() => {
    if ("Notification" in window) {
      Notification.requestPermission()
        .then((permission) => {
          if (permission === "granted") {
            // console.log("Notification permission granted.");
          } else if (permission === "denied") {
            console.warn("Notification permission denied.");
          } else {
            console.warn("Notification permission dismissed.");
          }
        })
        .catch((error) => {
          console.error("Error requesting notification permission:", error);
        });
    } else {
      console.warn("Notifications are not supported in this browser.");
    }

    // Handle foreground push notifications
    // onMessage(messaging, (payload) => {
    //   console.log("Push notification received:", payload);
    //   setNotifications((prev) => [...prev, payload.notification]);
    // });
  }, []);

  const sendQuestionNotification = async () => {
    if (!auth.currentUser) {
      console.error("User is not authenticated! Cannot send notifications.");
      return;
    }
    try {
      const questionsRef = collection(db, "questions");
      const snapshot = await getDocs(questionsRef);
      const quizQuestions = snapshot.docs.map((doc) => doc.data());
      if (quizQuestions.length > 0) {
        const randomQuestion = quizQuestions[Math.floor(Math.random() * quizQuestions.length)];
        const notificationTitle = "Daily Quiz Question";
        const notificationBody = randomQuestion.question;
        // Send notification
        new Notification(notificationTitle, {
          body: notificationBody,
          icon: "/path/to/icon.png", // Optional: Add an icon
        });
      }
    } catch (error) {
      console.error("Failed to send question notification:", error.message);
    }
  };

  const handleSectionChange = (newSection) => {
    setActiveSection(newSection);
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoginError("");
    setLoading(true);
    try {
      await signInWithEmailAndPassword(auth, email, password);
      setShowLogin(false);
    } catch (error) {
      console.error("Login failed:", error);
      setLoginError(error.message);
    } finally {
      setLoading(false);
    }
  };

  const handleSignUp = async (e) => {
    e.preventDefault();
    if (!agreeToTerms) {
      setSignUpError("You must agree to the Privacy Policy and User Agreement.");
      return;
    }
    setSignUpError("");
    setLoading(true);
    try {
      const userCredential = await createUserWithEmailAndPassword(auth, email, password);
      const newUser = userCredential.user;
      await setDoc(doc(db, "users", newUser.uid), {
        email: newUser.email,
        isActive: false, // Default to inactive
        accountType: "free", // Default to free account
      });
      setShowLogin(false);
    } catch (error) {
      console.error("Sign-up failed:", error);
      setSignUpError(error.message);
    } finally {
      setLoading(false);
    }
  };

  const handleSignOut = () => {
    signOut(auth);
  };

  useEffect(() => {
    const sendDailyNotifications = async () => {
      if (!auth.currentUser) return;
      const userUID = auth.currentUser.uid;
      const today = new Date().toISOString().split("T")[0]; // Get today's date in YYYY-MM-DD format
      const userDocRef = doc(db, "users", userUID);
      const userDoc = await getDoc(userDocRef);
      if (!userDoc.exists()) return;
      const userData = userDoc.data();
      const dailyProgress = userData.dailyProgress || {};
      if (dailyProgress[today]?.answeredQuestions >= 20) return; // User has already answered 20 questions today
      try {
        const questionsRef = collection(db, "questions");
        const snapshot = await getDocs(questionsRef);
        const quizQuestions = snapshot.docs.map((doc) => doc.data());
        if (quizQuestions.length > 0) {
          const randomQuestion = quizQuestions[Math.floor(Math.random() * quizQuestions.length)];
          const notificationTitle = "Daily Quiz Question";
          const notificationBody = randomQuestion.question;
          // Send notification
          new Notification(notificationTitle, {
            body: notificationBody,
            icon: "/path/to/icon.png", // Optional: Add an icon
          });
          // Update daily progress
          const updatedProgress = (dailyProgress[today]?.answeredQuestions || 0) + 1;
          await updateDoc(userDocRef, {
            [`dailyProgress.${today}`]: {
              answeredQuestions: updatedProgress,
              correctAnswers: dailyProgress[today]?.correctAnswers || 0,
            },
          });
        }
      } catch (error) {
        console.error("Failed to send daily notification:", error.message);
      }
    };
    const interval = setInterval(sendDailyNotifications, 3600000); // Send notifications every hour
    return () => clearInterval(interval);
  }, []);

  const fetchAccountType = async () => {
    if (user) {
      try {
        const userDoc = await getDoc(doc(db, "users", user.uid));
        if (userDoc.exists()) {
          setAccountType(userDoc.data().accountType || "free");
        } else {
          setAccountType("free");
        }
      } catch (error) {
        console.error("Failed to fetch account type:", error.message);
        setAccountType("free");
      }
    } else {
      setAccountType("free");
    }
  };

  useEffect(() => {
    fetchAccountType();
  }, [user]);

  const checkAccountType = () => {
    if (accountType !== "paid") {
      setShowAccountLimitModal(true);
      return false;
    }
    return true;
  };

  const handleCloseAccountLimitModal = () => {
    setShowAccountLimitModal(false);
  };

  // Delete account handler
  const handleDeleteAccount = async (e) => {
    e.preventDefault();
    setDeleteError("");
    setDeleteLoading(true);
    setDeleteSuccess(false);
    try {
      if (!auth.currentUser) throw new Error("No user logged in.");
      const user = auth.currentUser;
      // Re-authenticate
      const credential = window.firebase && window.firebase.auth
        ? window.firebase.auth.EmailAuthProvider.credential(user.email, deletePassword)
        : getAuth().EmailAuthProvider.credential(user.email, deletePassword);
      await user.reauthenticateWithCredential
        ? user.reauthenticateWithCredential(credential)
        : auth.currentUser.reauthenticateWithCredential(credential);
      // Delete user data in Firestore
      await deleteDoc(doc(db, "users", user.uid));
      // Optionally: delete userQuizzes, etc. (not implemented here)
      // Delete Firebase Auth user
      await user.delete();
      setDeleteSuccess(true);
      setTimeout(() => {
        setDeleteOpen(false);
        setDeletePassword("");
        setDeleteError("");
        setDeleteSuccess(false);
      }, 2000);
    } catch (err) {
      setDeleteError(err.message || "Failed to delete account.");
    } finally {
      setDeleteLoading(false);
    }
  };

  // Close menu on outside click
  useEffect(() => {
    if (!menuOpen) return;
    function handleClick(e) {
      if (menuRef.current && !menuRef.current.contains(e.target)) {
        setMenuOpen(false);
      }
    }
    document.addEventListener("mousedown", handleClick);
    return () => document.removeEventListener("mousedown", handleClick);
  }, [menuOpen]);

  // Sync stats data with Firestore every 20 seconds
  useEffect(() => {
    const syncData = async () => {
      if (!auth || !db || !auth.currentUser) return;
      try {
        const userUID = auth.currentUser.uid;
        const userDocRef = doc(db, "users", userUID);
        const userDoc = await getDoc(userDocRef);
        if (userDoc.exists()) {
          const userData = userDoc.data();
          setStats(userData.stats || {});
        }
      } catch (error) {
        console.error("Failed to sync data:", error.message);
      }
    };

    syncData(); // Initial sync

    const unsubscribe = auth && db && auth.currentUser
      ? onSnapshot(doc(db, "users", auth.currentUser.uid), (doc) => {
          if (doc.exists()) {
            setStats(doc.data().stats || {});
          }
        })
      : null;

    return () => unsubscribe && unsubscribe();
  }, [auth, db]);

  // Show loading animation only while app is truly loading (auth not ready)
  if (appLoading || !minTimePassed) {
    return (
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          height: "100vh",
          background: "#0F0F0F",
          minHeight: 320,
        }}
      >
        <div
          style={{
            transform: "scale(0.6) translateY(-45px)",
            transformOrigin: "top center",
          }}
        >
          <div
            style={{
              width: "60vw",
              maxWidth: 320,
              height: "200px",
              overflow: "hidden",
              position: "relative",
            }}
          >
            <div
              style={{
                position: "absolute",
                top: "-30px",
                width: "100%",
                height: "260px",
              }}
            >
              <Lottie
                animationData={loadingAnimation}
                loop={true}
                autoplay
                style={{
                  width: "100%",
                  height: "100%",
                }}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div
      className="h-screen w-screen flex flex-col bg-[#0F0F0F] text-[#f8f8f5] transition-colors duration-500"
      style={{
        fontFamily: "'InterVariable', Inter, Arial, sans-serif",
        background: "#0F0F0F", // fix PWA background
        minHeight: "100vh",
        minWidth: "100vw",
        overflow: "hidden"
      }}
    >
      {/* Inject font-face style */}
      <style>
        {`
          @font-face {
            font-family: 'InterVariable';
            src: url('./Inter-VariableFont_slnt,wght.ttf') format('truetype');
            font-weight: 100 900;
            font-style: normal;
          }
          html, body, #root {
            font-family: 'InterVariable', Inter, Arial, sans-serif;
            background: #0F0F0F !important;
            color: #f8f8f5;
            min-height: 100vh;
            min-width: 100vw;
            overflow-x: hidden;
          }
        `}
      </style>
      {/* Header */}
      <header className="p-4 shadow-md rounded-b-lg transition-colors duration-300" style={{background: activeSection === "quiz" ? "#1E83F6" : "#0F0F0F", borderBottomLeftRadius: 0, borderBottomRightRadius: 0}}>
        <div className="container mx-auto flex items-center justify-between">
          <div
            style={{
              cursor: "pointer", // Make it clickable
              transition: "transform 0.2s ease-in-out", // Smooth hover effect
              marginRight: "15px", // Added margin-right
            }}
            onClick={() => setActiveSection("home")}
            onMouseEnter={(e) => (e.currentTarget.style.transform = "scale(1.1)")} // Slightly bigger on hover
            onMouseLeave={(e) => (e.currentTarget.style.transform = "scale(1)")} // Reset size on hover out
          >
            <img src={Logo} alt="logo" style={{ height: "40px" }} /> {/* Adjust height as needed */}
          </div>
          <span className="text-lg font-semibold text-[#f8f8f5] tracking-wide drop-shadow-md" style={{ margin: "0 auto", textAlign: "center" }}>DailyDrill</span>
          <div style={{ display: "flex", alignItems: "center" }}>
            {/* Popup Menu Button */}
            <div style={{ position: "relative", marginLeft: 16 }}>
              <button
                aria-label="Open menu"
                onClick={() => setMenuOpen((v) => !v)}
                style={{
                  background: "none",
                  border: "none",
                  cursor: "pointer",
                  padding: 10,
                  borderRadius: 8,
                  minWidth: 40,
                  minHeight: 40,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center"
                }}
              >
                {/* Three horizontal dots icon */}
                <svg width="28" height="28" viewBox="0 0 28 28" fill="none">
                  <circle cx="6" cy="14" r="2" fill="#f8f8f5"/>
                  <circle cx="14" cy="14" r="2" fill="#f8f8f5"/>
                  <circle cx="22" cy="14" r="2" fill="#f8f8f5"/>
                </svg>
              </button>
              {menuOpen && (
                <div
                  ref={menuRef}
                  style={{
                    position: "absolute",
                    top: "110%",
                    right: 0,
                    background: "#232323",
                    color: "#f8f8f5",
                    borderRadius: 12,
                    boxShadow: "0 4px 16px rgba(0,0,0,0.18)",
                    minWidth: 180,
                    zIndex: 1000,
                    padding: "8px 0"
                  }}
                >
                  <MenuItem onClick={() => { setMenuOpen(false); setAboutOpen(true); }}>About</MenuItem>
                  <MenuItem onClick={() => { setMenuOpen(false); setHelpOpen(true); }}>Help</MenuItem>
                  <MenuItem onClick={() => { setMenuOpen(false); setLegalOpen(true); }}>Legal</MenuItem>
                  {user && (
                    <MenuItem onClick={() => { setMenuOpen(false); setSettingsOpen(true); }}>Settings</MenuItem>
                  )}
                </div>
              )}
            </div>
          </div>
        </div>
      </header>
      {/* About Page Overlay */}
      {aboutOpen && (
        <div
          style={{
            position: "fixed",
            top: 0, left: 0, right: 0, bottom: 0,
            background: "rgba(22,22,22,0.98)",
            zIndex: 2000,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: 24
          }}
        >
          <div
            style={{
              background: "#181818",
              borderRadius: 18,
              maxWidth: 420,
              width: "100%",
              padding: "36px 28px 28px 28px",
              boxShadow: "0 8px 32px rgba(0,0,0,0.25)",
              position: "relative"
            }}
          >
            <button
              onClick={() => setAboutOpen(false)}
              aria-label="Close About"
              style={{
                position: "absolute",
                top: 16,
                right: 16,
                background: "none",
                border: "none",
                color: "#bdbdb7",
                fontSize: 26,
                cursor: "pointer",
                padding: 4,
                borderRadius: 6
              }}
            >
              ×
            </button>
            <h2 style={{ fontSize: 28, fontWeight: 700, marginBottom: 16, color: "#f8f8f5" }}>About DailyDrill</h2>
            <p style={{ fontSize: 17, color: "#e5e5e0", marginBottom: 18 }}>
              DailyDrill is your daily learning companion. Create, share, and practice quizzes on any topic - alone or with friends. Track your progress, challenge yourself, and make learning a habit. Whether you're preparing for exams or just want to keep your mind sharp, DailyDrill helps you learn a little every day.
            </p>
            <div style={{ marginBottom: 18 }}>
              <span style={{ fontWeight: 600, fontSize: 15, color: "#ffffff" }}>Developer</span>
              <br />
              <a
                href="https://dotcompany.ch/"
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  color: "#ffffff",
                  textDecoration: "none",
                  fontWeight: 500,
                  fontSize: 16,
                  letterSpacing: 0.2,
                  display: "inline-block",
                  marginTop: 2,
                  marginBottom: 25,
                }}
              >
                dotcompany GmbH
              </a>
            </div>
            <div style={{ textAlign: "center", marginTop: 18 }}>
              <button
                onClick={() => setAboutOpen(false)}
                style={{
                  background: "#f8f8f5",
                  color: "#161616",
                  border: "none",
                  borderRadius: 8,
                  padding: "10px 28px",
                  fontWeight: 600,
                  fontSize: 16,
                  cursor: "pointer",
                  boxShadow: "0 2px 8px rgba(0,0,0,0.08)"
                }}
              >
                Back
              </button>
            </div>
          </div>
        </div>
      )}
      {/* Help Page Overlay */}
      {helpOpen && (
        <div
          style={{
            position: "fixed",
            top: 0, left: 0, right: 0, bottom: 0,
            background: "rgba(22,22,22,0.98)",
            zIndex: 2000,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: 24
          }}
        >
          <div
            style={{
              background: "#181818",
              borderRadius: 18,
              maxWidth: 480,
              width: "100%",
              padding: "36px 28px 28px 28px",
              boxShadow: "0 8px 32px rgba(0,0,0,0.25)",
              position: "relative"
            }}
          >
            <button
              onClick={() => setHelpOpen(false)}
              aria-label="Close Help"
              style={{
                position: "absolute",
                top: 16,
                right: 16,
                background: "none",
                border: "none",
                color: "#bdbdb7",
                fontSize: 26,
                cursor: "pointer",
                padding: 4,
                borderRadius: 6
              }}
            >
              ×
            </button>
            <h2 style={{ fontSize: 26, fontWeight: 700, marginBottom: 16, color: "#f8f8f5" }}>Help & FAQ</h2>
            <div style={{ fontSize: 16, color: "#e5e5e0" }}>
              <div style={{ marginBottom: 18 }}>
                <strong>How do I start a quiz?</strong>
                <div style={{ marginLeft: 8, marginTop: 2 }}>
                  Select or download a quiz from the Home section, then tap "Quiz" in the navigation bar to begin.
                </div>
              </div>
              <div style={{ marginBottom: 18 }}>
                <strong>How can I create my own quizzes?</strong>
                <div style={{ marginLeft: 8, marginTop: 2 }}>
                  Go to the Add section, create a new folder, and add your questions. You can also import questions in bulk using JSON.
                </div>
              </div>
              <div style={{ marginBottom: 18 }}>
                <strong>How do I share a quiz with friends?</strong>
                <div style={{ marginLeft: 8, marginTop: 2 }}>
                  After creating a quiz, use its share code visible in Profile to let others download it into their account.
                </div>
              </div>
              <div style={{ marginBottom: 18 }}>
                <strong>How is my progress tracked?</strong>
                <div style={{ marginLeft: 8, marginTop: 2 }}>
                  Your daily progress is tracked automatically as you answer questions. Check your stats in the Home section.
                </div>
              </div>
              <div style={{ marginBottom: 18 }}>
                <strong>Can I use DailyDrill for free?</strong>
                <div style={{ marginLeft: 8, marginTop: 2 }}>
                  Yes! You can use most features for free. Some advanced features like sharing quizzes require a paid account.
                </div>
              </div>
              <div style={{ marginBottom: 18 }}>
                <strong>Need more help?</strong>
                <div style={{ marginLeft: 8, marginTop: 2 }}>
                  Contact us at <a href="mailto:contact@dotcompany.ch" style={{ color: "#7be0ff", textDecoration: "underline" }}>contact@dotcompany.ch</a>
                </div>
              </div>
            </div>
            <div style={{ textAlign: "center", marginTop: 18 }}>
              <button
                onClick={() => setHelpOpen(false)}
                style={{
                  background: "#f8f8f5",
                  color: "#161616",
                  border: "none",
                  borderRadius: 8,
                  padding: "10px 28px",
                  fontWeight: 600,
                  fontSize: 16,
                  cursor: "pointer",
                  boxShadow: "0 2px 8px rgba(0,0,0,0.08)"
                }}
              >
                Back
              </button>
            </div>
          </div>
        </div>
      )}
      {/* Legal Page Overlay */}
      {legalOpen && (
        <div
          style={{
            position: "fixed",
            top: 0, left: 0, right: 0, bottom: 0,
            background: "rgba(22,22,22,0.98)",
            zIndex: 2000,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: 24
          }}
        >
          <div
            style={{
              background: "#181818",
              borderRadius: 18,
              maxWidth: 600,
              width: "100%",
              padding: "36px 28px 28px 28px",
              boxShadow: "0 8px 32px rgba(0,0,0,0.25)",
              position: "relative",
              overflowY: "auto",
              maxHeight: "90vh"
            }}
          >
            <button
              onClick={() => setLegalOpen(false)}
              aria-label="Close Legal"
              style={{
                position: "absolute",
                top: 16,
                right: 16,
                background: "none",
                border: "none",
                color: "#bdbdb7",
                fontSize: 26,
                cursor: "pointer",
                padding: 4,
                borderRadius: 6
              }}
            >
              ×
            </button>
            <h2 style={{ fontSize: 26, fontWeight: 700, marginBottom: 16, color: "#f8f8f5" }}>Privacy Policy & User Agreement</h2>
            <div style={{ fontSize: 15.5, color: "#e5e5e0", lineHeight: 1.7 }}>
              <h3 style={{ fontWeight: 600, marginTop: 18, marginBottom: 8 }}>Privacy Policy</h3>
              <div style={{ marginBottom: 10 }}>
                <b>What data do we collect?</b><br />
                We collect and store your email address for authentication and account management purposes.
              </div>
              <div style={{ marginBottom: 10 }}>
                <b>Why do we collect your data?</b><br />
                The legal basis for processing your personal data is contract fulfilment (Art. 6(1)(b) GDPR), as your email is required to create and manage your account.
              </div>
              <div style={{ marginBottom: 10 }}>
                <b>How long do we store your data?</b><br />
                Your email address and account data are stored as long as your account exists. You can request deletion of your account and data at any time.
              </div>
              <div style={{ marginBottom: 10 }}>
                <b>Where is your data stored?</b><br />
                Whereas the main data is stored on EU Servers, the authentication (login data, session ID) are handled/stored by US Servers (Firebase). By using this app, you explicitly acknowledge and agree to this data storage arrangement. You can only use the app if you agree to these terms regarding data storage locations.
              </div>
              <div style={{ marginBottom: 10 }}>
                <b>Do we share your data?</b><br />
                No, we do not share your data with third parties except as required by law or for essential service provision (e.g. Firebase as data processor).
              </div>
              <div style={{ marginBottom: 10 }}>
                <b>Your rights under GDPR and Swiss revDSG:</b>
                <ul style={{ margin: "6px 0 0 18px", padding: 0 }}>
                  <li>Access your data</li>
                  <li>Correct your data</li>
                  <li>Delete your data (right to be forgotten)</li>
                  <li>Restrict or object to processing</li>
                </ul>
                To exercise these rights, contact us at <a href="mailto:contact@dotcompany.ch" style={{ color: "#7be0ff", textDecoration: "underline" }}>contact@dotcompany.ch</a>. You also have the right to lodge a complaint with your local data protection authority.
              </div>
              <div style={{ marginBottom: 10 }}>
                <b>Sensitive data</b><br />
                Please do not insert or store any sensitive personal data in the app. The app is designed for general quiz use only.
              </div>
              <hr style={{ border: "none", borderTop: "1px solid #353535", margin: "18px 0" }} />
              <h3 style={{ fontWeight: 600, marginTop: 18, marginBottom: 8 }}>User Agreement</h3>
              <ol style={{ marginLeft: 18, marginBottom: 10 }}>
                <li>Account Use: You will not share your account with others.</li>
                <li>Data Input: You will not store sensitive personal data in the app.</li>
                <li>Quiz Content: You acknowledge that quiz content is user-generated or provided by the app administrators and may vary in accuracy.</li>
                <li>Termination: We reserve the right to terminate accounts in cases of misuse or violation of these terms.</li>
                <li>Liability: To the extent permitted by law, we are not liable for any direct or indirect damages resulting from use of the app.</li>
              </ol>
              <div style={{ marginBottom: 10 }}>
                <b>Contact</b><br />
                If you have any questions regarding privacy or these terms, please contact us at <a href="mailto:contact@dotcompany.ch" style={{ color: "#7be0ff", textDecoration: "underline" }}>contact@dotcompany.ch</a>.
              </div>
              <hr style={{ border: "none", borderTop: "1px solid #353535", margin: "18px 0" }} />
              <h3 style={{ fontWeight: 600, marginTop: 18, marginBottom: 8 }}>End User License Agreement (EULA) for DailyDrill</h3>
              <div style={{ marginBottom: 10 }}>
                <b>1. Introduction</b><br />
                This End User License Agreement (“Agreement”) is a legal agreement between you (“User” or “Licensee”) and dotcompany GmbH, the owner of DailyDrill (“App”).<br />
                By installing or using this App, you agree to be bound by the terms of this Agreement. If you do not agree, do not install or use the App.
              </div>
              <div style={{ marginBottom: 10 }}>
                <b>2. License Grant</b><br />
                We grant you a non-exclusive, non-transferable, non-sublicensable, revocable license to use the App solely for your personal, non-commercial use in accordance with this Agreement.
              </div>
              <div style={{ marginBottom: 10 }}>
                <b>3. Restrictions</b><br />
                You agree that you will not:
                <ul style={{ margin: "6px 0 0 18px", padding: 0 }}>
                  <li>Copy, modify, adapt, translate, or create derivative works of the App;</li>
                  <li>Reverse engineer, decompile, disassemble, or otherwise attempt to discover the source code;</li>
                  <li>Sell, rent, lease, sublicense, distribute, or commercially exploit the App;</li>
                  <li>Use the App for any commercial purpose without a separate commercial license agreement with us;</li>
                  <li>Remove, alter, or obscure any copyright, trademark, or proprietary notices.</li>
                </ul>
              </div>
              <div style={{ marginBottom: 10 }}>
                <b>4. Ownership</b><br />
                The App is licensed, not sold. We retain all rights, title, and interest in and to the App, including all intellectual property rights.
              </div>
              <div style={{ marginBottom: 10 }}>
                <b>5. Updates</b><br />
                We may provide updates, which shall be subject to this Agreement unless accompanied by separate terms.
              </div>
              <div style={{ marginBottom: 10 }}>
                <b>6. Termination</b><br />
                This Agreement is effective until terminated. It will terminate automatically if you fail to comply with any term. Upon termination, you must stop all use and delete all copies of the App.
              </div>
              <div style={{ marginBottom: 10 }}>
                <b>7. Disclaimer of Warranties</b><br />
                The App is provided “as is” without warranties of any kind. We disclaim all warranties, express or implied, including merchantability, fitness for a particular purpose, and non-infringement.
              </div>
              <div style={{ marginBottom: 10 }}>
                <b>8. Limitation of Liability</b><br />
                To the extent permitted by law, we shall not be liable for any indirect, incidental, consequential, or special damages, including loss of data, arising from use of the App.
              </div>
              <div style={{ marginBottom: 10 }}>
                <b>9. Governing Law</b><br />
                This Agreement is governed by the laws of Switzerland. Any disputes shall be subject to the exclusive jurisdiction of the courts of SG, Switzerland.
              </div>
              <div style={{ marginBottom: 10 }}>
                <b>10. Contact</b><br />
                For any questions regarding this Agreement, please contact us at <a href="mailto:contact@dotcompany.ch" style={{ color: "#7be0ff", textDecoration: "underline" }}>contact@dotcompany.ch</a>.
              </div>
            </div>
            <div style={{ textAlign: "center", marginTop: 18 }}>
              <button
                onClick={() => setLegalOpen(false)}
                style={{
                  background: "#f8f8f5",
                  color: "#161616",
                  border: "none",
                  borderRadius: 8,
                  padding: "10px 28px",
                  fontWeight: 600,
                  fontSize: 16,
                  cursor: "pointer",
                  boxShadow: "0 2px 8px rgba(0,0,0,0.08)"
                }}
              >
                Back
              </button>
            </div>
          </div>
        </div>
      )}
      {/* Settings Overlay */}
      {settingsOpen && user && (
        <div
          style={{
            position: "fixed",
            top: 0, left: 0, right: 0, bottom: 0,
            background: "rgba(22,22,22,0.98)",
            zIndex: 3000,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: 24
          }}
        >
          <div
            style={{
              background: "#181818",
              borderRadius: 18,
              maxWidth: 420,
              width: "100%",
              padding: "36px 28px 28px 28px",
              boxShadow: "0 8px 32px rgba(0,0,0,0.25)",
              position: "relative"
            }}
          >
            <button
              onClick={() => {
                setSettingsOpen(false);
                setDeleteOpen(false);
                setDeletePassword("");
                setDeleteError("");
                setDeleteSuccess(false);
              }}
              aria-label="Close Settings"
              style={{
                position: "absolute",
                top: 16,
                right: 16,
                background: "none",
                border: "none",
                color: "#bdbdb7",
                fontSize: 26,
                cursor: "pointer",
                padding: 4,
                borderRadius: 6
              }}
            >
              ×
            </button>
            <h2 style={{ fontSize: 22, fontWeight: 700, marginBottom: 18, color: "#f8f8f5" }}>Settings</h2>
            {/* Delete Account Setting */}
            <div style={{ marginBottom: 24 }}>
              <button
                onClick={() => { setDeleteOpen(true); }}
                style={{
                  background: "#e05a5a",
                  color: "#fff",
                  border: "none",
                  borderRadius: 8,
                  padding: "10px 28px",
                  fontWeight: 600,
                  fontSize: 16,
                  cursor: "pointer",
                  width: "100%",
                  marginBottom: 8
                }}
              >
                Delete Account
              </button>
              <div style={{ color: "#e05a5a", fontSize: 13, marginTop: 2 }}>
                This will irreversibly delete your account and all your data.
              </div>
            </div>
            <div style={{ textAlign: "center", marginTop: 24 }}>
              <button
                onClick={() => {
                  setSettingsOpen(false);
                  setDeleteOpen(false);
                  setDeletePassword("");
                  setDeleteError("");
                  setDeleteSuccess(false);
                }}
                style={{
                  background: "#f8f8f5",
                  color: "#161616",
                  border: "none",
                  borderRadius: 8,
                  padding: "8px 24px",
                  fontWeight: 500,
                  fontSize: 15,
                  cursor: "pointer",
                  marginTop: 8
                }}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}
      {/* Delete Account Overlay */}
      {deleteOpen && user && (
        <div
          style={{
            position: "fixed",
            top: 0, left: 0, right: 0, bottom: 0,
            background: "rgba(22,22,22,0.98)",
            zIndex: 4000,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: 24
          }}
        >
          <div
            style={{
              background: "#181818",
              borderRadius: 18,
              maxWidth: 420,
              width: "100%",
              padding: "36px 28px 28px 28px",
              boxShadow: "0 8px 32px rgba(0,0,0,0.25)",
              position: "relative"
            }}
          >
            <button
              onClick={() => { setDeleteOpen(false); setDeletePassword(""); setDeleteError(""); setDeleteSuccess(false); }}
              aria-label="Close Delete"
              style={{
                position: "absolute",
                top: 16,
                right: 16,
                background: "none",
                border: "none",
                color: "#bdbdb7",
                fontSize: 26,
                cursor: "pointer",
                padding: 4,
                borderRadius: 6
              }}
            >
              ×
            </button>
            <h2 style={{ fontSize: 22, fontWeight: 700, marginBottom: 12, color: "#f8f8f5" }}>Delete Account</h2>
            <div style={{ color: "#e05a5a", marginBottom: 12, fontWeight: 600 }}>
              Warning: This will irreversibly delete your account and all your data.
            </div>
            <form onSubmit={handleDeleteAccount}>
              <label style={{ color: "#e5e5e0", fontSize: 15, fontWeight: 500 }}>
                Please enter your password to confirm:
              </label>
              <input
                type="password"
                value={deletePassword}
                onChange={e => setDeletePassword(e.target.value)}
                style={{
                  width: "100%",
                  marginTop: 10,
                  marginBottom: 10,
                  padding: "10px",
                  borderRadius: 8,
                  border: "1px solid #353535",
                  background: "#232323",
                  color: "#f8f8f5",
                  fontSize: 16
                }}
                required
                autoFocus
              />
              {deleteError && (
                <div style={{ color: "#e05a5a", marginBottom: 8, fontSize: 14 }}>{deleteError}</div>
              )}
              {deleteSuccess && (
                <div style={{ color: "#3be07a", marginBottom: 8, fontSize: 14 }}>Account deleted successfully.</div>
              )}
              <button
                type="submit"
                disabled={deleteLoading}
                style={{
                  background: "#e05a5a",
                  color: "#fff",
                  border: "none",
                  borderRadius: 8,
                  padding: "10px 28px",
                  fontWeight: 600,
                  fontSize: 16,
                  cursor: deleteLoading ? "not-allowed" : "pointer",
                  marginTop: 8,
                  width: "100%",
                  opacity: deleteLoading ? 0.7 : 1
                }}
              >
                {deleteLoading ? "Deleting..." : "Delete Account"}
              </button>
            </form>
            <div style={{ textAlign: "center", marginTop: 18 }}>
              <button
                onClick={() => { setDeleteOpen(false); setDeletePassword(""); setDeleteError(""); setDeleteSuccess(false); }}
                style={{
                  background: "#f8f8f5",
                  color: "#161616",
                  border: "none",
                  borderRadius: 8,
                  padding: "8px 24px",
                  fontWeight: 500,
                  fontSize: 15,
                  cursor: "pointer",
                  marginTop: 8
                }}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
      {/* Login/Sign-Up Section */}
      {!user && (
        <div className="flex flex-col items-center justify-center flex-grow p-4">
          {/* Logo stays here */}
          <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
            <div
              style={{
                width: "50vw", // Reduced width for smaller animation
                maxWidth: 260, // Adjusted max width
                height: 150, // Reduced height for cropping
                overflow: "hidden", // Crop the animation
                position: "relative", // Ensure proper cropping
              }}
            >
              <div
                style={{
                  position: "absolute",
                  top: "-20px", // Crop the top
                  width: "100%",
                  height: "200px", // Ensure the animation fits within the cropped area
                }}
              >
                <Lottie
                  animationData={loadingAnimation2}
                  loop
                  style={{ width: "100%", height: "100%" }}
                />
              </div>
            </div>
          </div>
          <h2 className="text-2xl font-bold text-[#f8f8f5] mb-6 drop-shadow-md">
            Learn every day. Every topic.
          </h2>
          <form
            className="bg-[#181818] p-8 rounded-2xl shadow-2xl w-full max-w-md space-y-6 transition-all duration-500"
            onSubmit={handleLogin}
          >
            <div>
              <input
                type="email"
                placeholder="Email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="w-full p-3 rounded-md bg-[#232323] text-[#f8f8f5] border border-transparent focus:border-[#f8f8f5] focus:ring-2 focus:ring-[#f8f8f5] transition-colors duration-300"
                required
              />
            </div>
            <div>
              <input
                type="password"
                placeholder="Password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="w-full p-3 rounded-md bg-[#232323] text-[#f8f8f5] border border-transparent focus:border-[#f8f8f5] focus:ring-2 focus:ring-[#f8f8f5] transition-colors duration-300"
                required
              />
            </div>
            <div className="flex items-start space-x-2">
              <input
                type="checkbox"
                id="agreeToTerms"
                checked={agreeToTerms}
                onChange={(e) => setAgreeToTerms(e.target.checked)}
                className="mt-1"
              />
              <label htmlFor="agreeToTerms" className="text-sm text-[#e5e5e0]">
                I agree to the <button type="button" onClick={() => setLegalOpen(true)} className="text-[#7be0ff] underline">Privacy Policy and User Agreement</button>, including the data storage terms.
              </label>
            </div>
            {loginError && (
              <p className="text-red-400 text-sm transition-opacity duration-300">
                {loginError}
              </p>
            )}
            {signUpError && (
              <p className="text-red-400 text-sm transition-opacity duration-300">
                {signUpError}
              </p>
            )}
            <div className="flex justify-around">
              <button
                type="submit"
                className={`py-3 px-6 bg-[#232323] hover:bg-[#222] text-[#f8f8f5] rounded-2xl shadow-md transition-colors duration-300 ${
                  loading ? "opacity-50 cursor-not-allowed" : ""
                }`}
                disabled={loading}
              >
                {loading ? <BasicLoadingSpinner /> : "Log In"}
              </button>
              <button
                type="button"
                onClick={handleSignUp}
                className={`py-3 px-6 bg-[#232323] hover:bg-[#222] text-[#f8f8f5] rounded-2xl shadow-md transition-colors duration-300 ${
                  loading || !agreeToTerms ? "opacity-50 cursor-not-allowed" : ""
                }`}
                disabled={loading || !agreeToTerms}
              >
                Sign Up
              </button>
            </div>
          </form>
        </div>
      )}

      {/* Main Content */}
      {user && (
        <main className="flex-grow overflow-auto transition-all duration-500" style={{ minHeight: "100vh" }}>
          {activeSection === "home" && (
            <HomeSection
              auth={auth}
              db={db}
              handleSectionChange={handleSectionChange}
            />
          )}
          {activeSection === "quiz" && <QuizSection auth={auth} db={db} />}
          {activeSection === "addQuestions" && (
            <AddQuestionsSection
              auth={auth}
              db={db}
              checkAccountType={checkAccountType}
            />
          )}
          {activeSection === "profile" && <ProfileSection auth={auth} db={db} />}
          {/* {isAdmin && activeSection === "admin" && (
            <AdminPanel
              auth={auth}
              db={db}
              fetchUsers={fetchUsers}
              users={users}
              updateUser={updateUser}
            />
          )} */}
        </main>
      )}

      {/* Bottom Navigation */}
      {user && (
        <nav className="fixed bottom-0 left-0 right-0 bg-[#181818] border-t border-[#232323] z-50">
          <div className="flex justify-around items-center py-1">
            {sections.map((section) => (
              <button
                key={section.id}
                className={`flex flex-col items-center justify-center px-4 py-1 mb-1.5 transition-colors duration-200 w-full ${
                  activeSection === section.id
                    ? "text-[#1E83F6]" // Updated active icon color
                    : "text-[#bdbdb7] hover:text-[#f8f8f5]"
                }`}
                style={{
                  fontWeight: "normal",
                  fontSize: "1.1rem",
                  minWidth: 0,
                  maxWidth: "none",
                }}
                onClick={() => handleSectionChange(section.id)}
              >
                <span className="mb-0.5" style={{color: activeSection === section.id ? "#1E83F6" : "#bdbdb7"}}>
                  {section.icon}
                </span>
                <span className="text-xs leading-tight whitespace-nowrap">{section.title}</span>
              </button>
            ))}
          </div>
        </nav>
      )}

      {/* Account Limit Modal */}
      <AccountLimitModal
        isOpen={showAccountLimitModal}
        onClose={handleCloseAccountLimitModal}
      />
    </div>
  );
}

// Basic loading spinner (centered, simple)
function BasicLoadingSpinner() {
  return (
    <span
      style={{
        display: "inline-block",
        width: 24,
        height: 24,
        border: "3px solid #232323",
        borderTop: "3px solid #f8f8f5",
        borderRadius: "50%",
        animation: "spin 1s linear infinite",
        verticalAlign: "middle"
      }}
    >
      <style>
        {`@keyframes spin { 0% { transform: rotate(0deg);} 100% { transform: rotate(360deg);} }`}
      </style>
    </span>
  );
}

// Simple menu item component
function MenuItem({ children, onClick }) {
  return (
    <div
      onClick={onClick}
      style={{
        padding: "12px 20px",
        cursor: "pointer",
        fontSize: "1rem",
        transition: "background 0.15s",
        userSelect: "none"
      }}
      onMouseDown={e => e.preventDefault()}
      onTouchStart={e => e.preventDefault()}
      tabIndex={0}
      onKeyDown={e => { if (e.key === "Enter") onClick(); }}
      className="hover:bg-[#353535] focus:bg-[#353535]"
    >
      {children}
    </div>
  );
}